<div class="authenticating-loader">
  <!-- No i18n available at this point of the application life cycle -->
  <div class="loading">Authenticating</div>
</div>
